import React from 'react';

class AcctFilter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			agg: props.agg,
			refilter: props.refilter,
			threshhold: null
		};
	}

	static getDerivedStateFromProps(props, state) {
		return props;
	}

	componentDidUpdate(props, state){
	}

	componentDidMount() {
	}

	setFilterValue = (e) => {
		this.state.refilter({agg: e.target.value})
	}

	render(){
		return (
			<div className="col-lg-2 col-md-3 col-sm-4 pt-1 input-group">
				<select className="form-control" onChange={this.setFilterValue} title="Filter Account" value={this.state.agg}>
					<option value="DAY">DAY</option>
					<option value="MONTH" className={this.state.threshhold > 1 ? 'd-none' : ''}>MONTH</option>
					<option value="YEAR" className={this.state.threshhold > 0 ? 'd-none' : ''}>YEAR</option>
				</select>
			</div>
		)
	}
}
export default AcctFilter;